import gql from 'graphql-tag';

export const UpdateDispatchSummary = gql`
  mutation UpdateDispatchSummaryBulk($input: UpdateDispatchSummaryBulkInput!) {
    updateDispatchSummaryBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
